<template>
  <div class="product_box" style="width:4.69rem" @click="jumpDetail">
    <div class="pro_info flex-c-s-s">
      <van-image width="4.59rem" height="100%" :src="myinfo.iconUrl" style="margin-top: 0.1rem;" />
      <div class="pro_name van-multi-ellipsis--l2">
        <!-- <span v-if="myinfo.isStrict && type === 1" class="vip_pro_tag">严选</span> -->
        {{ myinfo.name }}
      </div>
      <div class="pro_brand_model van-ellipsis">{{ myinfo.brand }} | {{ myinfo.specifications }}</div>
      <!-- <div class="pro_tags">1</div> -->
      <div class="pro_bottom flex-r-sb-c">
        <div class="pro_money">￥<span
          style="font-size: 0.49rem;"
        >{{ myinfo.showPrice === 0? myinfo.price :'详询客服' }}</span></div>
        <div class="pro_btn">
          <van-icon v-if="myinfo.showPrice === 0" name="cart" @click.stop="toCart(myinfo)" />
          <van-icon v-if="myinfo.showPrice === 1" name="service" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { shoppingCart_addUnion } from '@/api/cart'
export default {
  props: {
    info: { type: Object, default: () => { } },
    type: { type: Number, default: 1 } // 1普通商品 2严选商品
  },
  data() {
    return {
      myinfo: this.info
    }
  },
  methods: {
    // 加入购物车
    toCart(item) {
      const parms = { productId: item.productId, priceNum: item.minQuantity }
      console.log(parms)
      shoppingCart_addUnion(parms).then(res => {
        this.$toast({ message: '加入成功！', duration: 1 * 1000 })
        this.$utils.cartNum(this.$store)
      })
    },
    // 进入详情
    jumpDetail() {
      sessionStorage.setItem('classify_pro_id', 'classfily' + this.id)
      sessionStorage.setItem('jump', true)
      this.$router.push('/product/detail?productId=' + this.myinfo.productId)
    }
  }
}
</script>
